import { Controller } from "@hotwired/stimulus"

// Дополняет нативный <details class="kit-menu"> закрытием по клику вне
// и по Escape, а на время открытия переносит .kit-menu__panel в <body> с
// position:fixed, координаты — от getBoundingClientRect() триггера.
// Без этого панель обрезается overflow-x:auto у .kit-table-wrap (адаптивные
// таблицы со скроллом) — overflow по одной оси схлопывает и другую ось тоже.
export default class extends Controller {
  connect() {
    this.onDocumentClick = (event) => {
      if (this.element.open && !this.element.contains(event.target) && !this.panelContains(event.target)) {
        this.element.open = false
      }
    }
    this.onKeydown = (event) => {
      if (event.key === "Escape" && this.element.open) {
        this.element.open = false
      }
    }
    this.onToggle = () => {
      if (this.element.open) {
        this.openPanel()
      } else {
        this.closePanel()
      }
    }
    this.onScroll = () => {
      if (this.element.open) this.element.open = false
    }

    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onKeydown)
    this.element.addEventListener("toggle", this.onToggle)
    window.addEventListener("scroll", this.onScroll, true)
    window.addEventListener("resize", this.onScroll)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onKeydown)
    this.element.removeEventListener("toggle", this.onToggle)
    window.removeEventListener("scroll", this.onScroll, true)
    window.removeEventListener("resize", this.onScroll)
    this.closePanel()
  }

  close() {
    this.element.open = false
  }

  panelContains(target) {
    return this.panel ? this.panel.contains(target) : false
  }

  openPanel() {
    const panel = this.element.querySelector(".kit-menu__panel")
    if (!panel) return

    this.panel = panel
    this.placeholder = document.createComment("kit-menu-panel")
    panel.before(this.placeholder)
    document.body.appendChild(panel)

    const rect = this.element.getBoundingClientRect()
    const alignEnd = this.element.classList.contains("kit-menu--end")

    panel.style.position = "fixed"
    panel.style.margin = "0"
    panel.style.top = `${rect.bottom + 6}px`
    if (alignEnd) {
      panel.style.left = "auto"
      panel.style.right = `${window.innerWidth - rect.right}px`
    } else {
      panel.style.left = `${rect.left}px`
      panel.style.right = "auto"
    }
  }

  closePanel() {
    if (!this.panel) return

    this.panel.style.position = ""
    this.panel.style.margin = ""
    this.panel.style.top = ""
    this.panel.style.left = ""
    this.panel.style.right = ""

    if (this.placeholder && this.placeholder.parentNode) {
      this.placeholder.replaceWith(this.panel)
    } else {
      this.element.appendChild(this.panel)
    }
    this.placeholder = null
    this.panel = null
  }
}
